export default __webpack_public_path__ + "static/media/46MD66.f5e18ea6.png";